import React from "react";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import Text from "@src/sharedComponents/Typography/Text";

interface Props {
  validationErrors: string[];
}

const ValidationErrors: React.FC<Props> = (props) => {
  const theme = useTheme();

  const redColor = theme.color.$textDanger;

  return (
    <ol
      style={{
        padding: "0 0 0 18px",
        color: redColor,
        fontSize: 12 /* Match bodySmall */,
      }}
    >
      {props.validationErrors.map((error, index) => (
        <li key={index}>
          <Text style={{ color: redColor }} variant="bodySmall">
            {error}
          </Text>
        </li>
      ))}
    </ol>
  );
};

export default ValidationErrors;
